import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GS_ROLE } from 'utils/constants'

interface Role {
  roleName: GS_ROLE
  permissions: string[]
}

interface PermissionsPayload {
  roles: Role[]
  viewPermissions: Record<string, any>
}

interface PermissionsState {
  isAdmin: boolean
  /**
   * @deprecated as of GREEN-10873 role based access control is sourced from settings and modified in settings UI
   */
  permissions: string[]
  /**
   * @deprecated as of GREEN-10873 role based access control is sourced from settings and modified in settings UI
   */
  viewPermissions: Record<string, any>
  roles: Role[]
}

const initialState: PermissionsState = {
  isAdmin: false,
  permissions: [],
  viewPermissions: {},
  roles: [] as Role[],
}

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state: PermissionsState, action: PayloadAction<PermissionsPayload>) => {
      state.isAdmin = action?.payload?.roles[0]?.permissions.indexOf('All') > -1
      state.permissions = action?.payload?.roles[0]?.permissions
      state.viewPermissions = action?.payload?.viewPermissions
      state.roles = action?.payload?.roles
    },
  },
})

export const { setPermissions } = permissionsSlice.actions

export default permissionsSlice.reducer
